import React from 'react';

function MethodBreakdownChart({ methodCounts }) {
  if (!methodCounts || Object.keys(methodCounts).length === 0) {
    return null;
  }

  const total = Object.values(methodCounts).reduce((sum, count) => sum + count, 0);
  
  const methodColors = {
    'Resistivity': 'bg-sky-500',
    'Spontaneous Potential': 'bg-green-500',
    'Induced Polarization': 'bg-rose-500',
    'Spectral IP': 'bg-pink-500',
    'Time-domain Electromagnetic': 'bg-teal-500',
    'Seismic MASW': 'bg-emerald-500',
    'Seismic REMI': 'bg-lime-500',
    'Seismic Reflection': 'bg-green-600',
    'Seismic Refraction': 'bg-green-400',
    'Magnetic': 'bg-orange-500',
    'Ground Penetrating Radar': 'bg-purple-500',
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
      <h3 className="text-lg font-semibold mb-4">Method Breakdown</h3>
      
      {/* Bar chart */}
      <div className="space-y-3 mb-4">
        {Object.entries(methodCounts).map(([method, count]) => {
          const percentage = (count / total) * 100;
          const color = methodColors[method] || 'bg-gray-500';
          
          return (
            <div key={method}>
              <div className="flex justify-between text-sm mb-1">
                <span className="font-medium">{method}</span>
                <span className="text-muted-foreground">{count}</span>
              </div>
              <div className="w-full bg-muted rounded-full h-2">
                <div
                  className={`${color} h-2 rounded-full transition-all`}
                  style={{ width: `${percentage}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
      
      {/* Total */}
      <div className="pt-3 border-t border-border">
        <div className="flex justify-between text-sm font-semibold">
          <span>Total Datasets</span>
          <span>{total}</span>
        </div>
      </div>
    </div>
  );
}

export default MethodBreakdownChart;
